import { Injectable } from '@angular/core';
import { FilterOperator } from '../../../core/query-strings/query-string-builder';

@Injectable({
  providedIn: 'root'
})
export class ManualCollectionFilterStateService {

  // Date filters
  dateRangeStart?: Date;
  dateRangeEnd?: Date;
  dateRangeFilterOperator: string = FilterOperator.Between;

  // Amount filters
  amountFrom?: number;
  amountTo?: number;
  amountFilterOperator: string = FilterOperator.Equal;

  // Location filters
  zoneId?: string;
  areaId?: string;
  blockId?: string;
}
